import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
// import blogbox from '../../data/blog.json';
import {t} from 'i18next';

class Servicesidebar extends Component {
    constructor(props){
        super(props)
        this.state = {
            servicetitle: props.servicetitle
        }
    }
    render() {
        const { services: serviceblock, blog: blogbox, servicetitle } = this.props
        
        return (
            <div className="sidebar_wrap">
                <div className="sidebar">
                    
                    <div className="sidebar_widgets mb-xl-30">
                        <div className="widget_title bg-light-blue">
                            <h5 className="no-margin text-custom-white fw-600"> {t(servicetitle)}</h5>
                        </div>
                        <ul className="custom sidebar-services">
                            {serviceblock.map((item, i) => (
                                <li key={i}>
                                    <Link to={item.link} className="text-custom-black fs-14">{item.title}<span><i className="fas fa-chevron-right" /></span></Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="sidebar_widgets mb-xl-30">
                        <div className="widget_title bg-light-blue">
                            <h5 className="no-margin text-custom-white fw-600">{t("opening hours")}</h5>
                        </div>
                        <table className="table text-custom-black">
                            <tbody>
                                <tr>
                                    <td>Mon – Wed</td>
                                    <td>-</td>
                                    <td className="text-right">9:00 AM - 7:00 PM</td>
                                </tr>
                                <tr>
                                    <td>Thursday</td>
                                    <td>-</td>
                                    <td className="text-right">9:00 AM - 6:30 PM</td>
                                </tr>
                                <tr>
                                    <td>Friday</td>
                                    <td>-</td>
                                    <td className="text-right">9:00 AM - 6:00 PM</td>
                                </tr>
                                <tr className="last-tr">
                                    <td>Sun - Sun</td>
                                    <td>-</td>
                                    <td className="text-right">CLOSED</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="sidebar_widgets">
                        <div className="widget_title bg-light-blue">
                            <h5 className="no-margin text-custom-white fw-600">{t("news londonbank")}</h5>
                        </div>
                        <ul className="custom popular_post">
                            {blogbox.slice(0, 3).map((item, i) => (
                                <li key={i}>
                                    <div className="post">
                                        <div className="post-wrapper">
                                            <div className="popular_post_img animate-img">
                                                <Link to={"/blog-single/" + item.id}>
                                                    <img src={process.env.PUBLIC_URL + "/" + item.photo} className="full-width image-fit" alt={item.title} />
                                                </Link>
                                            </div>
                                            <div className="popular_post_title">
                                                <div className="post-date">
                                                    <p className="text-light-blue no-margin">{item.postdate}</p>
                                                </div>
                                                <h6><Link to={"/blog-single/" + item.id} className="text-custom-black fs-16 fw-600">{item.title}</Link></h6>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = state => ({
    // services: state.data.services, 
    blog: state.data.blog

});
const mapDispatchToProps = dispatch => (
    bindActionCreators({}, dispatch)
);


export default connect(mapStateToProps, mapDispatchToProps)(Servicesidebar);

